import  React from 'react'
import { DashboardModel } from '../../../models/DashboardModel'
import { DashboardDetailModel } from '../../../models/DashboardDetailModel'
import { ISupportSpinner } from '../../../shared/Ajax'
import { GrantAgreementSummaryModel } from '../../../models/GrantAgreementSummaryModel'

interface Props {
    isConsultant: boolean
    isDraft: boolean
    model: DashboardModel
    applicationDetails: DashboardDetailModel
    showGrantAgreement?: boolean
    grantAgreement?: GrantAgreementSummaryModel
}

export interface State {
    loading: boolean
}

export default class AppicationSummary extends React.Component<Props, State> implements ISupportSpinner {
  constructor(props: Props) {
    super(props)

    this.state = { loading: false }
  }

  toggleSpinner(on: boolean, callback: { (): any }): void {
    this.setState({ loading: on }, callback)
  }

  render() {
    const {
      isConsultant, model, applicationDetails, grantAgreement, showGrantAgreement,
    } = this.props

    if (isConsultant) {
      return (
        <>
          <div className="row">
            <div className="col-md-1 pr-0">
              <strong>Agent</strong>
            </div>
            <div className="col-md-5 p-0">
              {model.consultancyName}
            </div>
          </div>

          <div className="emdg-callout">

            <div className="container">
              <div className="row mb-2">
                <div className="col-md-3">
                  <div className="row">
                    <div className="col-md-8 p-0">
                      <strong>Financial Year</strong>
                    </div>
                    <div className="col-md-4 p-0">
                      {applicationDetails.round}
                    </div>
                  </div>
                </div>
                <div className="col-md-3  p-0">
                  <strong className="float-right">Applicant</strong>
                </div>
                <div className="col-md-3">
                  {applicationDetails.organisationName}
                </div>
                <div className="col-md-3 p-0">
                  <div className="float-right">
                    <strong>{'Application ID '}</strong>
                    {applicationDetails.claimRandomIdentifier}
                  </div>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-4 p-0">
                      <strong>Primary Contact</strong>
                    </div>
                    <div className="col-md-8 p-0">
                      {(applicationDetails.modifiedPrimaryContactName && applicationDetails.modifiedPrimaryContactName.trim()) || applicationDetails.primaryContactName.trim()}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-4 p-0">
                      <strong>Agent Contact</strong>
                    </div>
                    <div className="col-md-8 p-0">
                      {(applicationDetails.modifiedAgentContactName && applicationDetails.modifiedAgentContactName.trim()) || applicationDetails.agentContactName.trim() || <div style={{ fontStyle: 'italic' }}>NA</div>}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-4 p-0">
                      <strong>Application Status</strong>
                    </div>
                    <div className="col-md-8 p-0">
                      {applicationDetails.applicationStatus}
                    </div>
                  </div>
                </div>
              </div>
              {showGrantAgreement && (
              <>
                <div className="row mb-2">
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-4 p-0">
                        <strong>Grant Agreement Status</strong>
                      </div>
                      <div className="col-md-8 p-0">
                        {grantAgreement.grantAgreementStatus}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-4 p-0">
                        <strong>Type of Grant</strong>
                      </div>
                      <div className="col-md-8 p-0">
                        {grantAgreement.grantType}
                      </div>
                    </div>
                  </div>
                </div>
              </>
              )}
            </div>
          </div>
        </>
      )
    }

    return (
      <>
        <div className="row">
          <div className="col-md-1 pr-0">
            <strong>Applicant</strong>
          </div>
          <div className="col-md-5 p-0">
            {model.organisationName}
          </div>
        </div>

        <div className="emdg-callout my-4">

          <div className="container">
            <div className="row mb-2">
              <div className="col-md-3">
                <div className="row">
                  <div className="col-md-8 p-0">
                    <strong>Financial Year</strong>
                  </div>
                  <div className="col-md-4 p-0">
                    {applicationDetails.round}
                  </div>
                </div>
              </div>
              <div className="col-md-9 p-0">
                <div className="float-right">
                  <strong>{'Application ID '}</strong>
                  {applicationDetails.claimRandomIdentifier}
                </div>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-4 p-0">
                    <strong>Primary Contact</strong>
                  </div>
                  <div className="col-md-8 p-0">
                    {(applicationDetails.modifiedPrimaryContactName && applicationDetails.modifiedPrimaryContactName.trim()) || applicationDetails.primaryContactName.trim()}
                  </div>
                </div>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-4 p-0">
                    <strong>Agent Contact</strong>
                  </div>
                  <div className="col-md-8 p-0">
                    {(applicationDetails.modifiedAgentContactName && applicationDetails.modifiedAgentContactName.trim()) || applicationDetails.agentContactName.trim() || <div style={{ fontStyle: 'italic' }}>NA</div>}
                  </div>
                </div>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-4 p-0">
                    <strong>Application Status</strong>
                  </div>
                  <div className="col-md-8 p-0">
                    {applicationDetails.applicationStatus}
                  </div>
                </div>
              </div>
            </div>
            {showGrantAgreement && (
            <>
              <div className="row mb-2">
                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-4 p-0">
                      <strong>Grant Agreement Status</strong>
                    </div>
                    <div className="col-md-8 p-0">
                      {grantAgreement.grantAgreementStatus}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-4 p-0">
                      <strong>Type of Grant</strong>
                    </div>
                    <div className="col-md-8 p-0">
                      {grantAgreement.grantType}
                    </div>
                  </div>
                </div>
              </div>
            </>
            )}
          </div>
        </div>
      </>
    )
  }
}
